import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { tagBackgroundColor, titles, navigation } from '../../../styles/colors';

const { spacing, colors } = THEME;

export const styleSheet = StyleSheet.create({
	addDonationBtnPopover: {
		padding: 0,
	},
	banner: {
		alignItems: 'center',
		background: tagBackgroundColor,
		display: 'flex',
		padding: '1rem 0.5rem',
		gap: 12,
	},
	bannerLink: {
		alignItems: 'center',
		color: colors.primary.main,
		display: 'inline-flex',
		fontWeight: 600,
		fontSize: 14,
		textDecoration: 'none',
	},

	container: {
		boxSizing: 'border-box',
		width: '100%',
		height: '100%',
		paddingTop: spacing.lg,
		backgroundColor: 'transparent !important',
	},
	databoardContainer: {
		boxSizing: 'border-box',
		width: '100%',
		height: '100%',
		backgroundColor: 'transparent !important',
	},
	infoHeaderContentBold: {
		marginTop: spacing.xs,
		marginBottom: 12,
		fontWeight: 600,
	},
	viewOnlyModeBannerContent: {
		display: 'flex',
		fontSize: 14,
		padding: '20px 20px 20px 40px',
		gap: 8,
	},
	viewOnlyModeBannerContainer: {
		justifyContent: 'space-between',
		display: 'flex',
		background: colors.tertiary.light,
		borderLeft: '3px solid #78DBFF',
		borderRadius: 3,
		boxSizing: 'border-box',
		color: titles,
		alignItems: 'flex-start',
		marginBottom: spacing.md,
	},
	loadingRow: {
		height: 300,
	},
	inKindDescription: {
		color: navigation,
		fontSize: 12,
		fontWeight: 400,
		marginTop: 4,
	},
});
